<template>
  <div id="app">
    <!-- This renders the currently active route's component -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped>
.menu-page {
  font-family: Arial, sans-serif;
  color: #000;
  background-color: #fff;
  padding: 20px;
}

/* Header Image */
.header-image img {
  width: 100%;
  height: auto;
  border-radius: 10px;
}

/* Filters Section */
.filters {
  display: flex;
  gap: 10px;
  margin: 20px 0;
  justify-content: center;
}

.filter-button {
  border: 1px solid black;
  background: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}

.filter-button:hover {
  background: black;
  color: white;
}

/* Bites Section */
.bites {
  margin: 40px 0;
}

.bites h2 {
  font-size: 28px;
  margin-bottom: 20px;
}

.bites ul {
  list-style: none;
  padding: 0;
}

.bites li {
  margin-bottom: 10px;
  font-size: 16px;
}

/* Lunch Section */
.lunch h2 {
  font-size: 28px;
  margin-bottom: 20px;
}

.download-button {
  display: inline-block;
  background: black;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}

.download-button:hover {
  background: #444;
}

/* Footer */
.back-link {
  display: inline-block;
  margin-top: 20px;
  text-decoration: none;
  color: black;
  font-size: 16px;
}

.back-link:hover {
  text-decoration: underline;
}
</style>
